import { AdminUsersState, AdminUser } from "./admin-users"

export default {
  setLoading(state: AdminUsersState, loading: boolean) {
    state.loading = loading
  },
  setUsers(state: AdminUsersState, users: AdminUser[]) {
    state.users = users
    state.totalCount = users.length
  },
  setUserSearch(state: AdminUsersState, value: string) {
    state.userSearch = value
  },
  setOrganizationSearch(state: AdminUsersState, value: string) {
    state.organizationSearch = value
  },
  setPage(state: AdminUsersState, page: number) {
    state.page = page
  },
  setItemsPerPage(state: AdminUsersState, items: number) {
    state.itemsPerPage = items
  },
  setTotalCount(state: AdminUsersState, count: number) {
    state.totalCount = count
  },
}
